import React, {Component} from 'react';
import { Row, Col, Button } from 'react-bootstrap';

export default class Offer extends Component{
    render() {
        return (
            <div className="card transition-item">
                <header className="bg-primary-violet">
                    <h1>Leistungen</h1>
                </header>
                <Row>
                    <Col sm={6}>
                        <div>
                            <h2>
                                <i className="fp fp-home"/>
                                Klavieruneterricht bei Ihnen zu Hause
                            </h2>
                        </div>
                        <div>
                            <h2>
                                <i className="fp fp-users"/>
                                Für Kinder und Erwachsene
                            </h2>
                        </div>
                        <i className="fp fp-heart"/>
                        <i className="fp fp-heart-outline"/>
                        <i className="fp fp-heart-outlined"/>
                        <i className="fp fp-star-empty"/>
                        <i className="fp fp-star-full"/>
                    </Col>
                    <Col sm={6}>
                        <div>
                            <h2>
                                <i className="fp fp-graduation-cap"/>
                                Für Anfänger, Wiedereinsteiger und Profis
                            </h2>
                        </div>
                    </Col>
                </Row>
                <p>hurr durr</p>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Offer.js